module.exports = __webpack_public_path__ + "static/media/m25.1450a92f.jpeg";